/**
 * 周期巡检统计清单 API
 */
import request from '@/service';

const STATION_WEB_PREFIX = '/route/station/web/';

// 分页查询巡检统计清单列表
export function getInspectionStatisticsPage(data) {
  return request({
    url: `${STATION_WEB_PREFIX}inspectionStatistics/page`,
    data,
  });
}

// 查看清单基础信息
export function getInspectionStatisticsDetail(params) {
  return request({
    url: `${STATION_WEB_PREFIX}inspectionStatistics/detail`,
    method: 'get',
    params,
  });
}

// 分页查询清单明细
export function getInspectionStatisticsDetailPage(data) {
  return request({
    url: `${STATION_WEB_PREFIX}inspectionStatistics/detailPage`,
    data,
  });
}

// 注：Excel 导出已统一接入下载中心（POST /route/support/web/sys/download/offlineExport），
// 请在前端调用 @/utils 的 offlineExport({ downloadType: 'inspection_statistics_export', jsonNode: {...} })。
